import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";

export const StyledOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 0 40px 40px;

  background-color: ${DIGIPOSTHEME.colors.white};
`;

export const StyledButton = styled.div`
  width: 240px;
`;
